// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1ra2a","select":"Header_select__2NiBF","clinic":"Header_clinic__3LzMl"};